import React from 'react';
export var BlockSpaces = function (_a) {
    var spaces = _a.spaces;
    if (spaces) {
        var arreglo = [];
        for (var i = 0; i < spaces; i++) {
            arreglo.push(i);
        }
        return (React.createElement("div", null, arreglo.map(function (value) { return (React.createElement(Space, { key: value })); })));
    }
    else {
        return React.createElement(Space, null);
    }
};
var Space = function () { return (React.createElement("div", { style: { height: '10px' } }, '\n')); };



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockSpaces.tsx
// module id = 164
// module chunks = 0